"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePunches = void 0;
const react_query_1 = require("react-query");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const fetchClient_1 = require("../../client/fetchClient");
const paths_1 = require("../../paths");
const DateManagement_1 = require("../../utils/DateManagement");
const EventEmitter_1 = require("../../utils/EventEmitter");
function usePunches({ employeeId, timeRange: { start, end }, isEligibilityEnabled = false, usageLocation, temporalRouting }) {
    const { host, clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const startDate = start ? (0, DateManagement_1.getDateString)(start) : undefined;
    const endDate = end ? (0, DateManagement_1.getDateString)(end) : undefined;
    const punchApiPath = isEligibilityEnabled
        ? (0, paths_1.GET_PUNCHES_ELIGIBILITY_API)(employeeId, startDate, endDate, temporalRouting)
        : (0, paths_1.GET_PUNCHES_API)(employeeId, startDate, endDate, temporalRouting);
    const apiName = isEligibilityEnabled ? 'getPunchesEligibility' : 'getPunches';
    return (0, react_query_1.useQuery)(['punches', punchApiPath], () => (0, fetchClient_1.getData)({
        path: punchApiPath,
        host,
        eventName: EventEmitter_1.taaEvents.GET_PUNCHES,
        metaData: {
            apiName,
            clientName
        },
        usageLocation
    }, currentStage), {
        enabled: !!employeeId && !!startDate && !!endDate,
        staleTime: 60 * 1000,
        retry: false
    });
}
exports.usePunches = usePunches;
